import { describeOrderFile, isOrderDocument } from '@api/b2b';
import { Button } from '@mantine/core';
import { ButtonVariant } from '@providers/Mantine/mantineTheme';
import React from 'react';
import styles from './b2b.module.css';
import { openSignedFile } from './utils';


/**
 * The order's documents: PIs, payment proofs, dispatch paperwork. Its JSON audit records
 * (as submitted, reviews, cancelled) are not documents; their content is on the Activity tab.
 */
const DocumentsTab: React.FC<{ files: string[]; open: (key: string) => Promise<{ url: string }> }> = ({ files: all, open }) => {
    const files = all.filter(isOrderDocument);
    return (
        <div className={styles.panelBody}>
            {files.length === 0 ? <span className={styles.muted}>No documents yet. The first PI appears here once it is issued.</span> : null}
            {[...files].sort().map((key) => (
                <div key={key} className={styles.between}>
                    <span className={styles.fieldValue}>{describeOrderFile(key)}</span>
                    <Button size="xs" variant={ButtonVariant.SUBTLE} onClick={() => void openSignedFile(() => open(key))}>
                        Open
                    </Button>
                </div>
            ))}
        </div>
    );
};

export default DocumentsTab;
